import Icon, { ICONS } from "@/assets/icons/icon";
import { Link, useLocation } from "react-router-dom";

export const BottomNavigation = () => {
  const location = useLocation();

  return (
    <nav className="w-screen h-[77px] bg-[#FFFFFF] z-50 px-0 border-t border-[#F1FBF4]">
      <div className="flex justify-between items-center h-full px-8">
        <NavLink to="/" icon="House" selected={location.pathname === "/"} />
        <NavLink
          to="/vehicle"
          icon="Vehicle"
          selected={location.pathname === "/vehicle"}
        />
        <NavLink to="/map" icon="Map" selected={location.pathname === "/map"} />
        {/* We don't have access to finances yet */}
        {/* <NavLink
          to="/settings"
          icon="Coins"
          selected={location.pathname === "/settings"}
        /> */}
      </div>
    </nav>
  );
};

const NavLink = ({
  to,
  icon,
  selected,
}: {
  to: string;
  icon: string;
  selected: boolean;
}) => {
  const icon_id = (selected ? `${icon}` : icon) as keyof typeof ICONS;

  return (
    <Link to={to} className={`flex items-center justify-center w-11 h-11`}>
      <Icon
        icon={icon_id}
        size="24px"
        className={`${selected ? "text-brand" : "text-[#D3D3D3]"}`}
      />
    </Link>
  );
};

export default BottomNavigation;
